/**
*
* ListTopics
*
*/

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import { Alert, ListGroup } from 'react-bootstrap';
import InfiniteScroll from 'components/interaction/InfiniteScroll/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import { idValues } from 'utils/arrays.js';
import fixedBottomStyle from 'utils/fixedBottomStyle.js';
import messages from '../messages.js';
import TopicItem from './TopicItem.jsx';

const MARGIN_BOTTOM = 40;

const Wrapper = styled(ListGroup)`
  .list-group-item.topic-flagged:not(.active) {
    background-color: var(--bs-alert-bg);
  }
`;

function ListTopics(props) {
  const { query, topics, activeId, fixed, marginBottom = MARGIN_BOTTOM, parentTopicId } = props;
  const { loading, hasMore, loadMore, totalCount } = topics;
  const fixedRef = useRef();
  const showList = () => (
    <Wrapper role="feed" aria-busy={loading}>
      {idValues(topics)
        .filter(Boolean) // Apparently, error when changing to subtopic, can have topics with undefined values
        .map((topic) => <TopicItem topic={topic} key={topic.id} active={activeId === topic.id} query={query} parentTopicId={parentTopicId} />)}
    </Wrapper>
  );
  if (fixed) {
    const style = fixedBottomStyle(marginBottom, fixedRef.current);
    return (
      <div style={style} className="no-print-max-height" ref={fixedRef}>
        {showList()}
      </div>
    );
  }

  if (loading && !totalCount) {
    return <Spinner />;
  }

  if (!totalCount) {
    return query ? null : (
      <Alert className="mx-4"><FormattedMessage {...messages.empty} /></Alert>
    );
  }
  return (
    <InfiniteScroll
      hasMore={hasMore}
      loadMore={loadMore}
      loading={loading}
    >
      {showList()}
    </InfiniteScroll>
  );
}

ListTopics.propTypes = {
  activeId: PropTypes.string,
  parentTopicId: PropTypes.string,
  query: PropTypes.string,
  topics: PropTypes.object,
  fixed: PropTypes.bool,
  marginBottom: PropTypes.number,
};

export default ListTopics;
